import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { CalendarRoutingModule } from './calendar-routing.module';
import { CalendarComponent } from './calendar.component';
import { BreadcrumbMenuModule } from 'src/app/common/modules/breadcrumb-menu/breadcrumb-menu.module';
import { CalendarContainerComponent } from './components/calendar-container/calendar-container.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { ExpectedVisitorComponent } from './components/expected-visitor/expected-visitor.component';
import { CalendarPickerComponent } from './components/calendar-picker/calendar-picker.component';
import { CalendarDetailsComponent } from './components/calendar-details/calendar-details.component';
import { VisitorCalendarContainerComponent } from './components/visitor-calendar-container/visitor-calendar-container.component';
import {
  MatNativeDateModule,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { ExampleHeader } from './components/calendar-picker/example-header/example-header.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CyclopsCalendarEffects } from 'src/app/state-management/effects/calendar.effects';
import { reducer } from 'src/app/state-management/reducers/calendar.reducer';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import {
  VisitorAgreement,
  VisitorInviteComponent,
} from './components/visitor-invite/visitor-invite.component';
import { VisitorInviteFormComponent } from './components/visitor-invite-form/visitor-invite-form.component';
import { ChartsModule } from 'src/app/common/modules/charts/charts.module';
import { QRCodeModule } from 'angularx-qrcode';
import { VisitorDetailsComponent } from './components/visitor-details/visitor-details.component';
import { MobileTableCardModule } from 'src/app/common/modules/mobile-table-card/mobile-table-card.module';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input-v16';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YY',
  },
  display: {
    dateInput: 'dd/MM/yy',
    monthYearLabel: 'MMM yy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YY',
  },
};
const module = [
  CommonModule,
  CalendarRoutingModule,
  BreadcrumbMenuModule,
  MaterialModule,
  MatNativeDateModule,
  FormsModule,
  ChartsModule,
  QRCodeModule,
  StoreModule.forFeature('aumyeCalendarState', reducer),
  EffectsModule.forFeature([CyclopsCalendarEffects]),
  MobileTableCardModule,
  NgxMatIntlTelInputComponent,
];
const components = [
  CalendarComponent,
  CalendarContainerComponent,
  ExpectedVisitorComponent,
  CalendarPickerComponent,
  CalendarDetailsComponent,
  VisitorCalendarContainerComponent,
  ExampleHeader,
  TimePickerComponent,
  VisitorAgreement,
  DateTimePickerComponent,
  VisitorInviteComponent,
  VisitorInviteFormComponent,
  VisitorDetailsComponent,
];
@NgModule({
  declarations: [...components],
  imports: [...module],
  providers: [
    DatePipe,
    // { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    // { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  exports: [...components],
})
export class CalendarViewModule {}
